<template>

  <b-modal
    id="add-simulation-charge-modal"
    :ok-title="$t('Add')"
    :title="$t('Add') + ' ' + typeFraisText"
    ok-only
    centered
    ok-variant="primary"
    @ok="handleOk">

    <b-form-group
      :label="$t('simulationCharge.Name')"
      class="medium-label mb-4"
      label-for="name-input">
      <b-form-input
        id="name-input"
        v-model="name"
        required
        type="text">
      </b-form-input>
    </b-form-group>

  </b-modal>

</template>

<script>

export default {

  name: "AddSimulationChargeModal",

  components: {},

  props: {
    typeFrais: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      name: null,
    }
  },

  computed: {

    typeFraisText() {
      return this.typeFrais ? this.$i18n.t(this.typeFrais.text) : ''
    }

  },

  emits: ['didAddSimulationCharge'],

  methods: {

    handleOk() {
      this.handleSubmit()
    },

    handleSubmit() {
      if (this.name != null && this.name.trim() !== '') {
        let simulationCharge = {
          typeFrais: this.typeFrais,
          name: this.name,
          prixTTC: null
        }
        this.$emit('didAddSimulationCharge', simulationCharge)
      }
      this.resetModal()
      this.hideModal()
    },

    resetModal() {
      this.name = null
    },

    hideModal() {
      this.$bvModal.hide('add-simulation-charge-modal')
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/simulation/components/AddSimulationChargeModal.vue